export { create, get } from "./basic/api";
export {
  supported,
  isUserVerifyingPlatformAuthenticatorAvailable,
  isSecurityKeySupported,
} from "./basic/supported";
export { schema } from "./basic/schema";
